import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import { setDash } from '../../../../../lib/common';
import './CsInquiryQuestionModal.scss';

const CsInquiryQuestionModal = (props) => {
  const { isOpen, data, closeModal } = props;
  const { question, answer, memo } = data;

  return (
    <Modal
      title="1:1 문의 질문 & 답변 내용 조회하기"
      isOpen={isOpen}
      width={600}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="cs-inquiry-question-modal">
        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc" colSpan={1}>
                질문 내용
              </td>
              <td className="text tc" colSpan={3}>
                {setDash(question)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={1}>
                답변 내용
              </td>
              <td className="text tc" colSpan={3}>
                {setDash(answer)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={1}>
                답변 작성자 메모
              </td>
              <td className="text tc" colSpan={3}>
                {setDash(memo)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default CsInquiryQuestionModal;
